import React from 'react';
import ContentLoader, { IContentLoaderProps } from 'react-content-loader';

const FileSelectorLoading = (props: IContentLoaderProps) => {
  return (
    <ContentLoader
      className="file-selector-loading"
      viewBox="0 0 600 36"
      width="100%"
      height={40}
      backgroundColor="#e7f1fc"
      foregroundColor="#ffffff"
      {...props}
    >
      <rect x="0" y="0" rx="4" ry="4" width="100%" height="36" />
    </ContentLoader>
  );
};

export default FileSelectorLoading;
